import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment-timezone";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const cookies = new Cookies();

/**
 * الطلبات المعلّقة لدى شركات التوصيل — عرض وتصدير فقط، لا يعدّل شيئاً.
 *
 *   معلّق  = order_from.status = 1
 *   التاريخ = prints.createdAt (تاريخ الطباعة)
 *   الشركة  = prints.name — مقصورة في الخادم على shiper.softdelete = 0
 *
 * البحث بزر فقط: تغيير التاريخ أو الشركة لا يرسل طلباً حتى يُضغط «بحث».
 * فلاتر الجدول (العمر · الاستبدال · البحث النصّي · عمود المخطط) تعمل
 * على النتائج المحمّلة بلا نداء جديد.
 *
 * المبالغ تُعرض كما هي مخزّنة (بالألف) — نفس بقية قوائم الطلبات.
 *
 * ⚠️ react-scripts 3.3.1: لا optional chaining ولا nullish coalescing.
 */

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Reem+Kufi:wght@500;600;700&family=IBM+Plex+Sans+Arabic:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap');

.pv{
  --bg:#ECEEE9; --card:#FFFFFF; --line:#D9DDD5; --line2:#E9ECE6;
  --ink:#161C24; --mut:#56606B; --faint:#7A838C;
  --stamp:#5B3CC4; --stamp-dk:#4A2FA6; --stamp-soft:#EFEAFB;
  --fresh:#2E7D4F; --fresh-bg:#E8F4EC;
  --aging:#B86E05; --aging-bg:#FCF1DC;
  --over:#C0392B; --over-bg:#FBE9E6;
  --kufi:'Reem Kufi','Noto Kufi Arabic','Tajawal',sans-serif;
  --sans:'IBM Plex Sans Arabic','Tajawal','Segoe UI',Tahoma,sans-serif;
  --mono:'IBM Plex Mono','SF Mono',Consolas,monospace;
  direction:rtl; background:var(--bg); color:var(--ink); min-height:100vh;
  font-family:var(--sans); font-size:15.5px; line-height:1.6;
  padding:28px 0 48px; -webkit-font-smoothing:antialiased;
}
.pv *{ box-sizing:border-box; }
.pv-shell{ padding-inline:max(16px,calc((100% - 1480px)/2)); }
.pv :focus-visible{ outline:2px solid var(--stamp); outline-offset:2px; }

/* ---------- العنوان ---------- */
.pv-title{ font-family:var(--kufi); font-weight:700; font-size:34px; line-height:1.2; margin:0; letter-spacing:0; }
.pv-lede{ margin:6px 0 22px; color:var(--mut); font-size:15.5px; max-width:66ch; }

/* ---------- شريط البحث ---------- */
.pv-bar{ background:var(--card); border:1px solid var(--line); border-radius:16px; padding:18px 20px; margin-bottom:22px; }
.pv-bar-grid{ display:grid; grid-template-columns:minmax(150px,1fr) minmax(150px,1fr) auto auto; gap:14px 16px; align-items:end; }
@media (max-width:900px){ .pv-bar-grid{ grid-template-columns:1fr 1fr; } .pv-bar-grid .pv-seg-wrap, .pv-bar-grid .pv-go-wrap{ grid-column:1 / -1; } }
.pv-lbl{ display:block; font-size:13px; font-weight:600; color:var(--mut); margin-bottom:6px; }
.pv-date{ font:inherit; font-family:var(--mono); font-size:15px; width:100%; padding:9px 11px; border:1px solid var(--line); border-radius:10px; background:#FAFBF9; color:var(--ink); }
.pv-date:focus{ border-color:var(--stamp); background:#fff; outline:none; box-shadow:0 0 0 3px var(--stamp-soft); }

.pv-seg{ display:inline-flex; border:1px solid var(--line); border-radius:11px; padding:3px; background:#FAFBF9; gap:3px; flex-wrap:wrap; }
.pv-seg button{ font:inherit; font-size:14.5px; font-weight:600; border:0; background:transparent; color:var(--mut); padding:7px 14px; border-radius:8px; cursor:pointer; display:inline-flex; align-items:center; gap:7px; white-space:nowrap; }
.pv-seg button:hover{ color:var(--ink); background:#F0F2EE; }
.pv-seg button[aria-pressed="true"]{ background:var(--ink); color:#fff; }
.pv-seg i{ width:9px; height:9px; border-radius:50%; display:inline-block; }

.pv-go{ font:inherit; font-size:15.5px; font-weight:700; background:var(--stamp); color:#fff; border:0; border-radius:11px; padding:10px 30px; cursor:pointer; min-height:42px; }
.pv-go:hover{ background:var(--stamp-dk); }
.pv-go:disabled{ opacity:.55; cursor:default; }

.pv-bar-foot{ display:flex; align-items:center; gap:8px; flex-wrap:wrap; margin-top:14px; }
.pv-qk{ font:inherit; font-size:13px; font-weight:600; border:1px dashed #C9CEC4; background:transparent; color:var(--mut); padding:4px 11px; border-radius:999px; cursor:pointer; }
.pv-qk:hover{ border-style:solid; color:var(--ink); }
.pv-dirty{ margin-inline-start:auto; font-size:13.5px; font-weight:600; color:var(--stamp); }
.pv-err{ margin-top:12px; background:var(--over-bg); color:var(--over); border-radius:10px; padding:9px 13px; font-size:14.5px; font-weight:600; }

/* ---------- الملخّص ---------- */
.pv-sum{ font-size:17px; margin:0 0 14px; color:var(--mut); }
.pv-sum b{ color:var(--ink); font-family:var(--mono); font-weight:600; }
.pv-sum .o{ color:var(--over); }

/* ---------- ممرّا الشركتين ---------- */
.pv-lanes{ display:grid; grid-template-columns:repeat(auto-fit,minmax(380px,1fr)); gap:16px; margin-bottom:22px; }
@media (max-width:480px){ .pv-lanes{ grid-template-columns:1fr; } }
.pv-lane{ background:var(--card); border:1px solid var(--line); border-radius:16px; padding:18px 20px 16px; border-top:5px solid var(--c); }
.pv-lane-h{ display:flex; align-items:baseline; justify-content:space-between; gap:12px; flex-wrap:wrap; }
.pv-lane-n{ font-family:var(--kufi); font-weight:700; font-size:28px; line-height:1.15; color:var(--c); margin:0; }
.pv-lane-big{ font-family:var(--mono); font-weight:600; font-size:30px; line-height:1; }
.pv-lane-big small{ font-family:var(--sans); font-size:14px; font-weight:600; color:var(--mut); margin-inline-start:6px; }
.pv-facts{ display:flex; flex-wrap:wrap; gap:4px 18px; margin:10px 0 2px; font-size:14px; color:var(--mut); }
.pv-facts b{ font-family:var(--mono); font-weight:600; color:var(--ink); }

/* المخطط: عمود لكل عدد أيام، اليوم صفر في اليمين */
.pv-hist-cap{ display:flex; justify-content:space-between; gap:8px; font-size:12.5px; color:var(--faint); margin:16px 0 6px; }
.pv-hist{ display:flex; align-items:flex-end; gap:3px; height:96px; border-bottom:1px solid var(--line); position:relative; }
.pv-col{ flex:1 1 0; min-width:4px; height:100%; display:flex; flex-direction:column; justify-content:flex-end; align-items:stretch; border:0; padding:0; background:transparent; cursor:default; position:relative; }
.pv-col.has{ cursor:pointer; }
.pv-col .bar{ display:block; border-radius:3px 3px 0 0; transform-origin:bottom; animation:pv-grow .5s cubic-bezier(.2,.7,.2,1) both; }
.pv-col .zero{ display:block; height:2px; background:var(--line2); }
.pv-col .cnt{ font-family:var(--mono); font-size:11px; font-weight:600; text-align:center; color:var(--mut); line-height:1.4; }
.pv-col.has:hover .bar{ filter:brightness(1.12); }
.pv-col.sel .bar{ box-shadow:0 0 0 2px var(--card), 0 0 0 4px var(--ink); }
.pv-col.dim .bar{ opacity:.28; }
@keyframes pv-grow{ from{ transform:scaleY(0); } to{ transform:scaleY(1); } }
.pv-axis{ display:flex; gap:3px; margin-top:4px; }
.pv-axis span{ flex:1 1 0; min-width:4px; font-family:var(--mono); font-size:11px; color:var(--faint); text-align:center; white-space:nowrap; overflow:visible; }
.pv-lane-empty{ height:96px; display:flex; align-items:center; justify-content:center; color:var(--faint); font-size:14px; border:1px dashed var(--line); border-radius:10px; margin-top:16px; }

/* ---------- الجدول ---------- */
.pv-panel{ background:var(--card); border:1px solid var(--line); border-radius:16px; overflow:hidden; }
.pv-tools{ display:flex; align-items:center; gap:8px; flex-wrap:wrap; padding:14px 16px; border-bottom:1px solid var(--line2); }
.pv-chip{ font:inherit; font-size:13.5px; font-weight:600; border:1px solid var(--line); background:#fff; color:var(--mut); padding:5px 12px; border-radius:999px; cursor:pointer; white-space:nowrap; }
.pv-chip:hover{ color:var(--ink); }
.pv-chip[aria-pressed="true"]{ background:var(--ink); border-color:var(--ink); color:#fff; }
.pv-chip.stamp[aria-pressed="true"]{ background:var(--stamp); border-color:var(--stamp); }
.pv-drill{ display:inline-flex; align-items:center; gap:8px; font-size:13.5px; font-weight:700; padding:5px 6px 5px 12px; border-radius:999px; background:var(--stamp-soft); color:var(--stamp-dk); }
.pv-drill button{ font:inherit; border:0; background:var(--stamp); color:#fff; width:22px; height:22px; border-radius:50%; cursor:pointer; line-height:1; font-size:14px; }
.pv-tools-sp{ flex:1; }
.pv-q{ font:inherit; font-size:14.5px; width:240px; max-width:100%; padding:7px 12px; border:1px solid var(--line); border-radius:10px; background:#FAFBF9; }
.pv-q:focus{ outline:none; border-color:var(--stamp); background:#fff; box-shadow:0 0 0 3px var(--stamp-soft); }
.pv-xl{ font:inherit; font-size:14px; font-weight:700; border:1px solid var(--ink); background:#fff; color:var(--ink); padding:7px 16px; border-radius:10px; cursor:pointer; }
.pv-xl:hover{ background:var(--ink); color:#fff; }

.pv-scroll{ overflow:auto; max-height:72vh; }
.pv-t{ width:100%; border-collapse:separate; border-spacing:0; font-size:14.5px; }
.pv-t th{ position:sticky; top:0; z-index:2; background:#F6F7F4; text-align:right; font-size:12.5px; font-weight:700; color:var(--mut); padding:10px 12px; border-bottom:1px solid var(--line); white-space:nowrap; }
.pv-t td{ padding:12px; border-bottom:1px solid var(--line2); vertical-align:top; text-align:right; }
.pv-t tbody tr:last-child td{ border-bottom:0; }
.pv-t tbody tr:hover td{ background:#FAFBF8; }
.pv-t td:first-child{ border-right:4px solid transparent; }
.pv-t tr.warn td:first-child{ border-right-color:#E3A33B; }
.pv-t tr.late td:first-child{ border-right-color:var(--over); }
.pv-id{ font-family:var(--mono); font-weight:600; font-size:15px; }
.pv-m{ font-family:var(--mono); font-size:13.5px; color:var(--mut); direction:ltr; unicode-bidi:isolate; white-space:nowrap; }
.pv-n{ font-family:var(--mono); font-weight:600; white-space:nowrap; text-align:left; }
.pv-t th.pv-n{ text-align:left; }
.pv-sub{ font-size:13px; color:var(--faint); }
.pv-name{ font-weight:600; }
.pv-items{ display:flex; flex-direction:column; gap:2px; min-width:190px; }
.pv-it{ font-size:13.5px; }
.pv-it b{ font-family:var(--mono); color:var(--stamp); margin-inline-start:6px; font-weight:600; unicode-bidi:isolate; }
.pv-co{ display:inline-flex; align-items:center; gap:6px; font-weight:600; white-space:nowrap; }
.pv-co i{ width:8px; height:8px; border-radius:2px; display:inline-block; }
.pv-est{ color:var(--faint); margin-inline-end:3px; font-weight:400; }

/* الاستبدال: ختم بنفسجي — الشيء الوحيد المائل في الصفحة */
.pv-repl{ display:inline-block; font-family:var(--kufi); font-weight:600; font-size:15px; letter-spacing:.3px; color:var(--stamp); border:1.5px dashed var(--stamp); border-radius:6px; padding:2px 11px; transform:rotate(-3deg); background:var(--stamp-soft); white-space:nowrap; }
.pv-no{ color:var(--faint); font-size:13.5px; }

.pv-days{ display:inline-flex; align-items:baseline; gap:4px; font-weight:600; padding:3px 10px; border-radius:8px; white-space:nowrap; }
.pv-days b{ font-family:var(--mono); font-size:16px; }
.pv-days.ok{ background:var(--fresh-bg); color:var(--fresh); }
.pv-days.warn{ background:var(--aging-bg); color:var(--aging); }
.pv-days.late{ background:var(--over-bg); color:var(--over); }

.pv-foot{ padding:10px 16px; border-top:1px solid var(--line2); font-size:13px; color:var(--faint); }
.pv-empty{ padding:56px 24px; text-align:center; color:var(--mut); }
.pv-empty strong{ display:block; font-family:var(--kufi); font-size:22px; color:var(--ink); margin-bottom:6px; font-weight:600; }

@media (max-width:640px){
  .pv-title{ font-size:26px; }
  .pv-lane-n{ font-size:23px; }
  .pv-q{ width:100%; }
}
@media (prefers-reduced-motion: reduce){
  .pv-col .bar{ animation:none; }
}
`;

const DAY_FMT = 'YYYY-MM-DD';
const HIST_CAP = 30;   // ما بعد ٣٠ يوماً يُجمع في عمود «٣٠+»

// هوية كل شركة — لون واحد يتكرّر في الممرّ والجدول والمبدّل.
// الشركات من shiper (softdelete = 0)؛ أي شركة تُفعَّل لاحقاً تأخذ لوناً
// ثابتاً من الاحتياطي حسب اسمها كي لا يتبدّل لونها بين زيارة وأخرى.
const COURIER_COLOR = { 'الياسمين': '#0F7B6C', 'بوكسي': '#A8551E' };
const SPARE_COLORS = ['#2F5DA8', '#8A3B6E', '#5E7A1F', '#B0412E', '#3D6B73', '#7A5A12'];
const colorOf = (name) => {
    if (COURIER_COLOR[name]) return COURIER_COLOR[name];
    let h = 0;
    for (let i = 0; i < String(name).length; i++) h = (h * 31 + String(name).charCodeAt(i)) >>> 0;
    return SPARE_COLORS[h % SPARE_COLORS.length];
};

const AGE_COLOR = { ok: '#2E7D4F', warn: '#D9900F', late: '#C0392B' };

const QUICK = [
    { days: 7, label: '٧ أيام' },
    { days: 30, label: '٣٠ يوماً' },
    { days: 90, label: '٩٠ يوماً' },
];

// المبالغ مخزّنة بالألف — تُعرض كما هي بفواصل
const fmt = (n) => {
    const x = Number(n);
    if (!isFinite(x)) return '—';
    return (Math.round(x * 100) / 100).toLocaleString('en-US');
};

const dayWord = (d) => d === 0 ? 'اليوم' : d === 1 ? 'يوم' : d === 2 ? 'يومان' : (d <= 10 ? 'أيام' : 'يوماً');

class PendingDelivery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // مسودة الفلاتر — لا تُرسل حتى يُضغط «بحث»
            from: moment().subtract(30, 'days').format(DAY_FMT),
            to: moment().format(DAY_FMT),
            company: 'All',
            companies: [],

            loading: false,
            error: '',
            data: null,

            // فلاتر الجدول — محلّية على النتائج المحمّلة
            age: 'all',
            onlyRepl: false,
            q: '',
            drill: null,   // { company, day } من الضغط على عمود في المخطط
        };
    }

    componentDidMount() {
        // قائمة الشركات فقط — ليست بحثاً
        axios.get(host + 'delivery/pending/companies', { headers: this.header() })
            .then(res => {
                const d = (res.data && res.data.data) || {};
                this.setState({ companies: d.companies || [] });
            })
            .catch(() => toast.error('تعذّر تحميل قائمة الشركات'));
    }

    header() {
        return { token: cookies.get("token") };
    }

    setQuick(days) {
        this.setState({
            from: moment().subtract(days, 'days').format(DAY_FMT),
            to: moment().format(DAY_FMT),
        });
    }

    search = (e) => {
        if (e) e.preventDefault();
        const { from, to, company } = this.state;
        if (!from || !to) { this.setState({ error: 'اختر تاريخ البداية وتاريخ النهاية.' }); return; }
        if (from > to) { this.setState({ error: 'تاريخ البداية بعد تاريخ النهاية — بدّلهما.' }); return; }

        this.setState({ loading: true, error: '' });
        const qs = '?from=' + encodeURIComponent(from)
            + '&to=' + encodeURIComponent(to)
            + '&company=' + encodeURIComponent(company);

        axios.get(host + 'delivery/pending' + qs, { headers: this.header() })
            .then(res => {
                const d = (res.data && res.data.data) || null;
                this.setState({ data: d, loading: false, drill: null, age: 'all', onlyRepl: false, q: '' });
            })
            .catch(err => {
                const msg = (err && err.response && err.response.data && err.response.data.message) || 'تعذّر تحميل الطلبات. تحقّق من الاتصال وأعد البحث.';
                this.setState({ loading: false, error: Array.isArray(msg) ? msg.join('، ') : msg });
            });
    };

    isDirty() {
        const d = this.state.data;
        if (!d) return false;
        const f = d.filters;
        return f.from !== this.state.from || f.to !== this.state.to || f.company !== this.state.company;
    }

    visibleOrders() {
        const d = this.state.data;
        if (!d) return [];
        const { age, onlyRepl, drill } = this.state;
        const q = this.state.q.trim();
        return d.orders.filter(o => {
            if (drill) {
                if (o.company !== drill.company) return false;
                if (drill.day >= HIST_CAP ? o.days < HIST_CAP : o.days !== drill.day) return false;
            }
            if (age !== 'all' && o.age !== age) return false;
            if (onlyRepl && !o.replacement) return false;
            if (!q) return true;
            return String(o.id) === q
                || (o.phone && o.phone.indexOf(q) !== -1)
                || (o.phone2 && o.phone2.indexOf(q) !== -1)
                || (o.customer && o.customer.indexOf(q) !== -1);
        });
    }

    exportExcel() {
        const orders = this.visibleOrders();
        if (!orders.length) { toast.info('لا توجد طلبات معروضة للتصدير'); return; }
        const rows = orders.map(o => ({
            'رقم الوصل': o.id,
            'الزبون': o.customer,
            'الهاتف': o.phone,
            'هاتف ٢': o.phone2,
            'المحافظة': o.government,
            'المنطقة': o.city,
            'المنتجات': o.items.map(it => it.name + ' × ' + it.count).join(' ، '),
            'عدد القطع': o.items_count,
            'استبدال': o.replacement ? 'نعم' : 'لا',
            'السعر': o.price,
            'التوصيل': o.shipping,
            'الصافي': o.net,
            'الشركة': o.company,
            'رقم القائمة': o.print_id,
            'تاريخ الطباعة': o.printed_at,
            'أيام التعليق': o.days,
            'الملاحظات': [o.notes, o.notes2].filter(Boolean).join(' — '),
        }));
        const ws = XLSX.utils.json_to_sheet(rows);
        ws['!cols'] = [8, 18, 14, 14, 12, 16, 48, 9, 8, 10, 9, 10, 12, 11, 17, 11, 30].map(w => ({ wch: w }));
        const wb = XLSX.utils.book_new();
        wb.Workbook = { Views: [{ RTL: true }] };
        XLSX.utils.book_append_sheet(wb, ws, 'المعلّق');
        const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const f = this.state.data.filters;
        const co = f.company === 'All' ? 'الياسمين-وبوكسي' : f.company;
        saveAs(new Blob([buf], { type: 'application/octet-stream' }),
            'معلق_' + co + '_' + f.from + '_' + f.to + '.xlsx');
    }

    // ------------------------------------------------------------------

    renderBar() {
        const s = this.state;
        const segs = [{ name: 'All', label: 'الكل' }].concat(s.companies.map(c => ({ name: c.name, label: c.name })));
        return (
            <form className="pv-bar" onSubmit={this.search} noValidate>
                <div className="pv-bar-grid">
                    <div>
                        <label className="pv-lbl" htmlFor="pv-from">طُبع من</label>
                        <input id="pv-from" type="date" className="pv-date" value={s.from}
                            onChange={e => this.setState({ from: e.target.value })} />
                    </div>
                    <div>
                        <label className="pv-lbl" htmlFor="pv-to">إلى</label>
                        <input id="pv-to" type="date" className="pv-date" value={s.to}
                            onChange={e => this.setState({ to: e.target.value })} />
                    </div>
                    <div className="pv-seg-wrap">
                        <span className="pv-lbl" id="pv-co-l">شركة التوصيل</span>
                        <div className="pv-seg" role="group" aria-labelledby="pv-co-l">
                            {segs.map(c =>
                                <button key={c.name} type="button" aria-pressed={s.company === c.name ? 'true' : 'false'}
                                    onClick={() => this.setState({ company: c.name })}>
                                    {c.name !== 'All' ? <i style={{ background: colorOf(c.name) }} /> : null}
                                    {c.label}
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="pv-go-wrap">
                        <button type="submit" className="pv-go" disabled={s.loading}>
                            {s.loading ? 'جارٍ البحث…' : 'بحث'}
                        </button>
                    </div>
                </div>

                <div className="pv-bar-foot">
                    <span className="pv-sub">فترة سريعة:</span>
                    {QUICK.map(q =>
                        <button key={q.days} type="button" className="pv-qk" onClick={() => this.setQuick(q.days)}>
                            آخر {q.label}
                        </button>
                    )}
                    {this.isDirty() ? <span className="pv-dirty">غيّرت الفلاتر — اضغط «بحث» لتحديث النتائج</span> : null}
                </div>

                {s.error ? <div className="pv-err" role="alert">{s.error}</div> : null}
            </form>
        );
    }

    renderSummary() {
        const d = this.state.data;
        const t = d.totals;
        if (!t.orders) return null;
        return (
            <p className="pv-sum">
                <b>{t.orders}</b> طلباً معلّقاً بمبلغ <b>{fmt(t.amount)}</b> ألف، والصافي المتوقّع <b>{fmt(t.net)}</b>
                {t.late ? <span> · <b className="o">{t.late}</b> منها تجاوزت {d.buckets.late - 1} أيام</span> : null}
                {t.replacements ? <span> · <b>{t.replacements}</b> استبدال</span> : null}
            </p>
        );
    }

    renderLanes() {
        const d = this.state.data;
        const b = d.buckets;
        // محور وسلّم مشتركان بين الممرّين كي تُقارن الشركتان بالعين
        let axisMax = 10, peak = 1;
        d.by_company.forEach(g => {
            if (g.max_days > axisMax) axisMax = g.max_days;
            g.days_hist.forEach(n => { if (n > peak) peak = n; });
        });
        const cols = Math.min(axisMax, HIST_CAP) + 1;

        return (
            <div className="pv-lanes">
                {d.by_company.map(g => this.renderLane(g, cols, peak, b))}
            </div>
        );
    }

    renderLane(g, cols, peak, b) {
        const c = colorOf(g.company);
        const drill = this.state.drill;
        const bins = [];
        for (let i = 0; i < cols; i++) bins.push(0);
        g.days_hist.forEach((n, day) => { bins[Math.min(day, cols - 1)] += n; });
        // إن جُمع الذيل في العمود الأخير صار «٣٠+»
        const tailMerged = cols - 1 === HIST_CAP;

        const ageOf = (day) => day >= b.late ? 'late' : day >= b.warn ? 'warn' : 'ok';
        const tick = (day) => {
            if (day === 0) return 'اليوم';
            if (day === b.warn || day === b.late) return String(day);
            if (day === cols - 1) return tailMerged ? HIST_CAP + '+' : String(day);
            return '';
        };

        return (
            <section key={g.company} className="pv-lane" style={{ '--c': c }} aria-label={'طلبات ' + g.company}>
                <div className="pv-lane-h">
                    <h2 className="pv-lane-n">{g.company}</h2>
                    <div className="pv-lane-big">{g.orders}<small>طلب معلّق</small></div>
                </div>
                <div className="pv-facts">
                    <span>المبلغ <b>{fmt(g.amount)}</b></span>
                    <span>الصافي <b>{fmt(g.net)}</b></span>
                    <span>القطع <b>{g.items}</b></span>
                    <span>استبدال <b>{g.replacements}</b></span>
                    {g.orders ? <span>أقدم طلب <b>{g.max_days}</b> {dayWord(g.max_days)}</span> : null}
                </div>

                {g.orders ? (
                    <div>
                        <div className="pv-hist-cap">
                            <span>كم يوماً عند المندوب</span>
                            <span>اضغط عموداً لعرض طلباته</span>
                        </div>
                        <div className="pv-hist">
                            {bins.map((n, day) => {
                                const sel = drill && drill.company === g.company && drill.day === day;
                                const dim = drill && !sel;
                                const label = (tailMerged && day === cols - 1 ? HIST_CAP + ' يوماً فأكثر' : day === 0 ? 'طُبعت اليوم' : day + ' ' + dayWord(day)) + ': ' + n + ' طلب';
                                return (
                                    <button key={day} type="button"
                                        className={'pv-col' + (n ? ' has' : '') + (sel ? ' sel' : '') + (dim ? ' dim' : '')}
                                        disabled={!n} title={label} aria-label={label} aria-pressed={sel ? 'true' : 'false'}
                                        onClick={() => this.setState({ drill: sel ? null : { company: g.company, day } })}>
                                        {n ? <span className="cnt">{n}</span> : null}
                                        {n
                                            ? <span className="bar" style={{ height: Math.max(6, n / peak * 72) + 'px', background: AGE_COLOR[ageOf(day)], animationDelay: (day * 14) + 'ms' }} />
                                            : <span className="zero" />}
                                    </button>
                                );
                            })}
                        </div>
                        <div className="pv-axis" aria-hidden="true">
                            {bins.map((n, day) => <span key={day}>{tick(day)}</span>)}
                        </div>
                    </div>
                ) : (
                    <div className="pv-lane-empty">لا طلبات معلّقة لهذه الشركة في الفترة المختارة</div>
                )}
            </section>
        );
    }

    renderTable() {
        const s = this.state;
        const d = s.data;
        const orders = this.visibleOrders();
        const t = d.totals;
        const ageChips = [
            { k: 'all', label: 'الكل', n: t.orders },
            { k: 'late', label: 'متأخر جداً', n: t.late },
            { k: 'warn', label: 'متأخر', n: t.warn },
            { k: 'ok', label: 'حديث', n: t.ok },
        ];

        return (
            <div className="pv-panel">
                <div className="pv-tools">
                    {s.drill ? (
                        <span className="pv-drill">
                            {s.drill.company} · {s.drill.day >= HIST_CAP ? HIST_CAP + '+ يوماً' : s.drill.day === 0 ? 'طُبعت اليوم' : s.drill.day + ' ' + dayWord(s.drill.day)}
                            <button type="button" aria-label="إلغاء فلتر المخطط" onClick={() => this.setState({ drill: null })}>×</button>
                        </span>
                    ) : null}
                    {ageChips.map(c =>
                        <button key={c.k} type="button" className="pv-chip" aria-pressed={s.age === c.k ? 'true' : 'false'}
                            onClick={() => this.setState({ age: c.k })}>{c.label} {c.n}</button>
                    )}
                    <button type="button" className="pv-chip stamp" aria-pressed={s.onlyRepl ? 'true' : 'false'}
                        onClick={() => this.setState({ onlyRepl: !s.onlyRepl })}>الاستبدالات فقط {t.replacements}</button>
                    <span className="pv-tools-sp" />
                    <input className="pv-q" type="search" placeholder="رقم الوصل، الهاتف، الاسم" aria-label="بحث في النتائج"
                        value={s.q} onChange={e => this.setState({ q: e.target.value })} />
                    <button type="button" className="pv-xl" onClick={() => this.exportExcel()}>تصدير Excel</button>
                </div>

                {orders.length === 0 ? (
                    <div className="pv-empty">
                        <strong>{d.orders.length ? 'لا طلبات تطابق هذا الفلتر' : 'لا طلبات معلّقة'}</strong>
                        {d.orders.length
                            ? 'ألغِ فلتر المخطط أو غيّر فلتر العمر أو نص البحث.'
                            : 'كل الطلبات المطبوعة في هذه الفترة حُسمت بتسليم أو راجع.'}
                    </div>
                ) : (
                    <div className="pv-scroll">
                        <table className="pv-t">
                            <thead>
                                <tr>
                                    <th>رقم الوصل</th>
                                    <th>الزبون</th>
                                    <th>العنوان</th>
                                    <th>المنتجات</th>
                                    <th>استبدال</th>
                                    <th className="pv-n">السعر</th>
                                    <th className="pv-n">التوصيل</th>
                                    <th className="pv-n">الصافي</th>
                                    <th>الشركة</th>
                                    <th>الطباعة</th>
                                    <th>معلّق منذ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map(o =>
                                    <tr key={o.id} className={o.age}>
                                        <td className="pv-id">{o.id}</td>
                                        <td>
                                            <div className="pv-name">{o.customer || '—'}</div>
                                            <div className="pv-m">{o.phone}</div>
                                            {o.phone2 ? <div className="pv-m">{o.phone2}</div> : null}
                                        </td>
                                        <td>
                                            <div>{o.government}</div>
                                            {o.city ? <div className="pv-sub">{o.city}</div> : null}
                                        </td>
                                        <td>
                                            <div className="pv-items">
                                                {o.items.length ? o.items.map((it, i) =>
                                                    <div key={i} className="pv-it">{it.name}<b>×{it.count}</b></div>
                                                ) : <span className="pv-no">—</span>}
                                            </div>
                                        </td>
                                        <td>{o.replacement ? <span className="pv-repl">استبدال</span> : <span className="pv-no">لا</span>}</td>
                                        <td className="pv-n">{fmt(o.price)}</td>
                                        <td className="pv-n" style={{ color: 'var(--mut)' }}
                                            title={o.shipping_source === 'priced' ? 'من تسعير القائمة' : 'تقدير من سعر الشركة — القائمة غير مسعّرة'}>
                                            {o.shipping_source === 'priced' ? null : <span className="pv-est" aria-label="تقديري">≈</span>}{fmt(o.shipping)}
                                        </td>
                                        <td className="pv-n">{fmt(o.net)}</td>
                                        <td><span className="pv-co"><i style={{ background: colorOf(o.company) }} />{o.company}</span></td>
                                        <td>
                                            <div className="pv-m">{o.printed_at}</div>
                                            <div className="pv-sub">قائمة <span className="pv-m">#{o.print_id}</span></div>
                                        </td>
                                        <td>
                                            <span className={'pv-days ' + o.age}>
                                                {o.days === 0 ? 'اليوم' : <span><b>{o.days}</b> {dayWord(o.days)}</span>}
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
                {orders.length ? (
                    <div className="pv-foot">يعرض {orders.length} من {d.orders.length} · المبالغ بالألف دينار · ≈ توصيل تقديري من سعر الشركة لأن القائمة لم تُسعَّر بعد · الأقدم في الأعلى</div>
                ) : null}
            </div>
        );
    }

    render() {
        const d = this.state.data;
        return (
            <div className="pv">
                <style>{CSS}</style>
                <div className="pv-shell">
                    <h1 className="pv-title">معلّق عند شركات التوصيل</h1>
                    <p className="pv-lede">طلبات طُبعت وسُلّمت للمندوب ولم تُحسم بعد بتسليم أو راجع.</p>

                    {this.renderBar()}

                    {d ? (
                        <div>
                            {this.renderSummary()}
                            {this.renderLanes()}
                            {this.renderTable()}
                        </div>
                    ) : (
                        <div className="pv-panel">
                            <div className="pv-empty">
                                <strong>{this.state.loading ? 'جارٍ البحث…' : 'لم تبحث بعد'}</strong>
                                {this.state.loading ? '' : 'حدّد تاريخ الطباعة من وإلى، واختر الشركة، ثم اضغط «بحث».'}
                            </div>
                        </div>
                    )}
                </div>
                <ToastContainer position="bottom-left" autoClose={4000} rtl />
            </div>
        );
    }
}

export default PendingDelivery;
